
export interface SocialMedia {
    twitter: boolean;
    twitterLink: string;
    facebook: boolean;
    facebookLink: string;
    linkedIn: boolean;
    linkedInLink: string;
    instagram: boolean;
    instagramLink: string;
    youtube: boolean;
    youtubeLink: string;
};

export interface PreferanceSetting {
    logoDisplay: boolean;
    imageId?: string;
    imageName?: string;
    imagefile?: string;
    imageSource?: File;
    logoLink: string;
    emailBackgroundColor: string;
    emailTitleColor: string;
    subject: string;
    footerDisplay: boolean;
    footer: string;
    footerFontColor: string;
};

export interface ComponentTemplate {
    noteTemplate: string;
    alertCotainerTemplate: string;
    warningAlertTitleTempalte: string;
    critcalAlertTitleTempalte: string;
    alertItemTemplate: string;
};

export interface AlertEmailHtmlTemplate {
    emailTemplate: string;
    componentTemplate: ComponentTemplate;
    emailPreference: PreferanceSetting;
};


